import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  private socket: Socket;

  constructor() {
    this.socket = io(environment.DeviceSocketEndPoint);
  }

  // Listen for updates from the server
  listenForUpdates(token: any): Observable<any> {
    return new Observable((observer) => {
      this.socket.on(token, (data: any) => {
        observer.next(data);
      });
    });
  }

  // Disconnect socket when no longer needed
  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }
}
